import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHeartIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 13 13",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.20859 7.62742L5.79668 11.9108C5.98711 12.0886 6.23848 12.1876 6.5 12.1876C6.76152 12.1876 7.01289 12.0886 7.20332 11.9108L11.7914 7.62742C12.5633 6.90886 13 5.90086 13 4.84715V4.69988C13 2.92508 11.7178 1.41179 9.96836 1.1198C8.81055 0.926833 7.63242 1.30515 6.80469 2.13289L6.5 2.43757L6.19531 2.13289C5.36758 1.30515 4.18945 0.926833 3.03164 1.1198C1.28223 1.41179 0 2.92508 0 4.69988V4.84715C0 5.90086 0.436719 6.90886 1.20859 7.62742Z",
		fill: "currentColor"
	})
});
export default SvgHeartIcon;
